export const SUBMIT_FORM = 'schemaForm/SUBMIT_FORM';
export const SUBMIT_FORM_SUCCESS = 'schemaForm/SUBMIT_FORM_SUCCESS';
export const SUBMIT_FORM_FAILURE = 'schemaForm/SUBMIT_FORM_FAILURE';
export const SUBMIT_FORM_CANCELLED = 'schemaForm/SUBMIT_FORM_CANCELLED';
export const REGISTER_FORM = 'schemaForm/REGISTER_FORM';
export const SKIP_REGISTRATION = 'schemaForm/SKIP_REGISTRATION';
export const CLEAR_FORM = 'schemaForm/CLEAR_FORM';
export const RESET_FORM = 'schemaForm/RESET_FORM';
export const INIT_ARRAY = 'schemaForm/INIT_ARRAY';
export const CLEAR_ARRAY = 'schemaForm/CLEAR_ARRAY';
export const ADD_ARRAY_ITEM = 'schemaForm/ADD_ARRAY_ITEM';
export const SWAP_ARRAY_ITEMS = 'schemaForm/SWAP_ARRAY_ITEMS';
export const REMOVE_ARRAY_ITEM = 'schemaForm/REMOVE_ARRAY_ITEM';
export const INSERT_PLACEHOLDER = 'schemaForm/INSERT_PLACEHOLDER';
export const CLEAR_PLACEHOLDER = 'schemaForm/CLEAR_PLACEHOLDER';
export const TOGGLE_ARRAY_ITEM = 'schemaForm/TOGGLE_ARRAY_ITEM';
export const COLLAPSE_ALL_ARRAY_ITEMS = 'schemaForm/COLLAPSE_ALL_ARRAY_ITEMS';
export const EXPAND_ALL_ARRAY_ITEMS = 'schemaForm/EXPAND_ALL_ARRAY_ITEMS';
export const CHANGE_FIELD = 'schemaForm/CHANGE_FIELD';
export const CHANGE_DISCRIMINATOR_FIELD = 'schemaForm/CHANGE_DISCRIMINATOR_FIELD';
export const SET_FORM_DATA = 'schemaForm/SET_FORM_DATA';
export const BLUR_FIELD = 'schemaForm/BLUR_FIELD';
export const VALIDATE_ON_BLUR = 'schemaForm/VALIDATE_ON_BLUR';
export const FOCUS_FIELD = 'schemaForm/FOCUS_FIELD';
export const VALIDATE_FORM = 'schemaForm/VALIDATE_FORM';
export const CUSTOM_VALIDATION = 'schemaForm/CUSTOM_VALIDATION';
export const SET_UI = 'schemaForm/SET_UI';
export const SET_BUSY = 'schemaForm/SET_BUSY';
